// extracted by mini-css-extract-plugin
export var form = "styles-module--form--a9XYz";
export var section = "styles-module--section--DvatW";
export var title = "styles-module--title--HRTE3";